import { front, top, right, bottom, left, back, Side } from 'src/constants/sides'

export const getGlobalPlateSide = ({ parentSide, selfSide }: { [key in 'parentSide' | 'selfSide']: Side }): Side => {
  switch ([parentSide, selfSide].toString()) {
    /** FRONT */
    case [front, front].toString():
    case [top, left].toString():
    case [right, left].toString():
    case [bottom, left].toString():
    case [left, right].toString():
    case [back, back].toString():
      return front
    /** TOP */
    case [front, top].toString():
    case [top, front].toString():
    case [right, top].toString():
    case [bottom, back].toString():
    case [left, top].toString():
    case [back, top].toString():
      return top
    /** RIGHT */
    case [front, right].toString():
    case [top, bottom].toString():
    case [right, front].toString():
    case [bottom, top].toString():
    case [left, back].toString():
    case [back, left].toString():
      return right
    /** BOTTOM */
    case [front, bottom].toString():
    case [top, back].toString():
    case [right, bottom].toString():
    case [bottom, front].toString():
    case [left, bottom].toString():
    case [back, bottom].toString():
      return bottom
    /** LEFT */
    case [front, left].toString():
    case [top, top].toString():
    case [right, back].toString():
    case [bottom, bottom].toString():
    case [left, front].toString():
    case [back, right].toString():
      return left
    /** BACK */
    case [front, back].toString():
    case [top, right].toString():
    case [right, right].toString():
    case [bottom, right].toString():
    case [left, left].toString():
    case [back, front].toString():
      return back
    default:
      throw console.warn(
        `getGlobalPlateSide went wrong with params: parentSide = ${parentSide} & selfSide = ${selfSide}`
      )
  }
}
